module.exports = __webpack_public_path__ + "static/img/4.3d01481.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/4.png
// module id = kRDD
// module chunks = 0